// components/ContactModal.jsx
import React from 'react';
import './styles/ContactModal.css'; // Custom styling

const ContactModal = ({ onClose }) => {
  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Contact Support</h2>
        <p>Need help? We're just a message away!</p>
        <p><strong>📞 Phone:</strong> +91 8608462631</p>
        <p><strong>✉️ Email:</strong> support@area51india.com</p>
        <button className="close-btn" onClick={onClose}>Close</button>
      </div>
    </div>
  );
};

export default ContactModal;
